export default "__VITE_ASSET__BGbCq97k__"